import TextMessage from "./TextMessage";
import ImageMessage from "./ImageMessage";
import VideoMessage from "./VideoMessage";
import AudioMessage from "./AudioMessage";
import DocumentMessage from "./DocumentMessage";
import TemplateMessage from "./TemplateMessage";
import { MESSAGE_TYPES } from "../constants";

const MESSAGE_TYPE_REGISTRY = {
  [MESSAGE_TYPES.TEXT]: TextMessage,
  [MESSAGE_TYPES.IMAGE]: ImageMessage,
  [MESSAGE_TYPES.VIDEO]: VideoMessage,
  [MESSAGE_TYPES.AUDIO]: AudioMessage,
  [MESSAGE_TYPES.DOCUMENT]: DocumentMessage,
  [MESSAGE_TYPES.TEMPLATE]: TemplateMessage,
  [MESSAGE_TYPES.BUTTON]: TextMessage,
  [MESSAGE_TYPES.INTERACTIVE]: TextMessage,
};

export const getMessageComponent = (messageType) => {
  return MESSAGE_TYPE_REGISTRY[messageType] || null;
};

export const isSupportedMessageType = (messageType) => {
  return MESSAGE_TYPE_REGISTRY[messageType] !== undefined;
};

export default MESSAGE_TYPE_REGISTRY;
